module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_drag_and_drop_builders.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_drag_and_drop_builders.png
// module id = n3e/
// module chunks = 0